import * as React from "react";
import { Row } from "./styles";
import { LegalDataType } from "./types";

const FooterLegal = ({ legalData }: { legalData: LegalDataType }) => {
  /** By default we prepend a copyright icon; in the US we append TM instead */
  const legalDisplayName =
    legalData.id === "PFUS"
      ? `${legalData.legalName} \u2122`
      : `\u00A9 ${legalData.legalName}`;

  return (
    <Row>
      <span>{legalDisplayName}</span>
      <span>{legalData.legalNotice}</span>
    </Row>
  );
};

export default FooterLegal;
